import * as React from "react";
let Logo ="login.png";

export default class PanelEmailEtPassword extends React.Component <{}> {
  state = {
    identifiant: '',
    motdepasse:''
  }  
  constructor(props) {
    super(props);
    
    this.handleChangeIdentifiant = this.handleChangeIdentifiant.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleValidate = this.handleValidate.bind(this);
    
    //permet de disable le bouton next
    //this.props.onChange(undefined);
   
  }
  
  componentDidMount () {
		setTimeout(function(){
    
    const node = document.querySelectorAll('button');
    node.forEach(element => {
      //console.log(element);
      const item=element.querySelectorAll('span')
      if(item[0]!= undefined)if(item[0].innerHTML=="Next")item[0].innerHTML="Etape suivante";
      if(item[0]!= undefined)if(item[0].innerHTML=="Back")item[0].innerHTML="Etape précédente";
      if(item[0]!= undefined)if(item[0].innerHTML=="Submit")item[0].innerHTML="Envoyer";
      
     // console.log(item);
    });
    document.getElementById("step2").focus();
  },0);
 
    //const node2=node.querySelectorAll('button');
    
  }
 
  handleChangeIdentifiant(e)
  {
    this.setState({identifiant:e.target.value});
    this.props.onChange(e.target.value,this.state.motdepasse);
  }
  handleChangePassword(e)
  {
    this.setState({motdepasse:e.target.value});
    this.props.onChange(this.state.identifiant,e.target.value);
  }
  handleValidate(e)
  {
    if (e.key === 'Enter') {
      this.props.onChange(undefined,undefined);
    }
  }
  /*handleChange(e) {
   // console.log(e.target.value);
    this.props.onChange(e.target);
  }*/

  render() {
    const{...state}=this.props;
    return (
      <div style={{padding:'10px'}}>
        <h3>{state.etape}</h3>
        <p>Entrez une adresse Email  </p>
        <div>
          <img height="250" src={Logo} /> 
        </div>
        <div style={{margin:'-20px 0 50px 0'}}>
        <p>Entrez votre identifiant </p>
        <input style={{fontSize:'16px'}}id='step2' type="text" onChange={this.handleChangeIdentifiant} placeholder="nom.prenom"/>
        <p>Entrez votre mot de passe</p>
        <input style={{fontSize:'16px'}} id="pswd1" type="password" onKeyDown ={this.handleValidate} onChange={this.handleChangePassword} placeholder="Mot de passe"/>
        </div>
      </div>
    );
  }
}
